import { render, staticRenderFns } from "./schedule-corrective.vue?vue&type=template&id=1bf4ff10&scoped=true"
import script from "./schedule-corrective.vue?vue&type=script&lang=js"
export * from "./schedule-corrective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4ff10",
  null
  
)

export default component.exports